export enum ViewType {
  Graph = 'Graph',
  Table = 'Table',
}

export enum ViewData {
  Individual = 'Individual',
  Aggregate = 'Aggregate',
}

export enum ViewRange {
  Last24Hours = '24 Hours',
  Last7Days = '7 Days',
  Last30Days = '30 Days',
}

export const maximumMachinesForIndividualView = 10
